import React, { Component, Fragment } from "react";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledCarousel,
} from "reactstrap";
import Footer from "./partials/Footer";
import Header from "./partials/Header";
import { connect } from "react-redux";
import img1 from "../assets/imgs/gallerySub1.png";
import img2 from "../assets/imgs/gallerySub2.png";
import img3 from "../assets/imgs/gallerySub3.png";

import { fetchGames } from "../redux/actions/gameActions";

import moment from "moment";
import { getGallery } from "../redux/actions/galleryActions";
export class Gallery extends Component {
  state = { searchText: "", active: -1, date: -1, modal: false, images: [] };
  componentDidMount() {
    this.props.fetchGames();
    this.props.getGallery();
  }
  toggle = (e) => {
    e.preventDefault();
    this.setState({ modal: !this.state.modal });
  };
  render() {
    let { game, gallery } = this.props;

    return (
      <Fragment>
        <Header
          {...this.props}
          path={["Home", "Gallery"]}
          login={false}
          heading="Gallery"
        />
        <Container className="text-white-1 margin-top-fix">
          {/* <Row className="align-items-center justify-content-end">
            <Col xl={6}>
              <Row className="align-items-center">
                <Col xl={3} md={4}>
                  <div className="dropdown-wrapper position-relative">
                    <button
                      className="pointer"
                      onClick={(e) => {
                        this.setState(
                          this.state.active == 0
                            ? { active: -1 }
                            : { active: 0 }
                        );
                      }}
                      onBlur={(e) => {
                        this.setState(
                          this.state.active == 0
                            ? { active: -1 }
                            : { active: 0 }
                        );
                      }}
                    >
                      {this.state.date == -1
                        ? "Date"
                        : moment(this.state.date).format("DD MMM YYYY")}
                      <i className="fa fa-angle-down px-2 text-red-1"></i>
                    </button>{" "}
                    <div
                      className={`cdropdown-items ${
                        this.state.active == 0 ? "active" : ""
                      }`}
                    >
                      <div className="cdropdown-item">
                        <input
                          type="date"
                          onChange={(e) =>
                            this.setState({ date: e.target.value, active: -1 })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={3} md={4} className="mt-3 mt-md-0">
                  <div className="dropdown-wrapper position-relative">
                    <button
                      className="pointer"
                      onClick={(e) => {
                        this.setState(
                          this.state.active == 1
                            ? { active: -1 }
                            : { active: 1 }
                        );
                      }}
                      onBlur={(e) => {
                        this.setState(
                          this.state.active == 1
                            ? { active: -1 }
                            : { active: 1 }
                        );
                      }}
                    >
                      City <i className="fa fa-angle-down px-2 text-red-1"></i>
                    </button>
                    <div
                      className={`cdropdown-items ${
                        this.state.active == 1 ? "active" : ""
                      }`}
                    >
                      <div className="cdropdown-item">Hamburg</div>
                    </div>
                  </div>
                </Col>
                <Col xl={3} md={4} className="mt-3 mt-md-0">
                  <div className="dropdown-wrapper position-relative">
                    <button
                      className="pointer"
                      onClick={(e) => {
                        this.setState(
                          this.state.active == 2
                            ? { active: -1 }
                            : { active: 2 }
                        );
                      }}
                      onBlur={(e) => {
                        this.setState(
                          this.state.active == 2
                            ? { active: -1 }
                            : { active: 2 }
                        );
                      }}
                    >
                      Scenerio
                      <i className="fa fa-angle-down px-2 text-red-1"></i>
                    </button>
                    <div
                      className={`cdropdown-items ${
                        this.state.active == 2 ? "active" : ""
                      }`}
                    >
                      {game.games &&
                        game.games != -1 &&
                        game.games.map((game) => (
                          <div
                            key={`GameScenerio${game.id}`}
                            className="cdropdown-item"
                          >
                            {game.title}
                          </div>
                        ))}
                    </div>
                  </div>
                </Col>
                <Col xl={3} className="d-none d-xl-block">
                  <div className="dropdown-wrapper position-relative">
                    <button
                      className="pointer"
                      onClick={(e) => {
                        this.setState(
                          this.state.active == 3
                            ? { active: -1 }
                            : { active: 3 }
                        );
                      }}
                      onBlur={(e) => {
                        this.setState(
                          this.state.active == 3
                            ? { active: -1 }
                            : { active: 3 }
                        );
                      }}
                    >
                      Past Events{" "}
                      <i className="fa fa-angle-down px-2 text-red-1"></i>
                    </button>
                    <div
                      className={`cdropdown-items ${
                        this.state.active == 3 ? "active" : ""
                      }`}
                    >
                      <div className="cdropdown-item">No Record Found</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xl={3} className="mt-3 mt-xl-0">
              <Row className="align-items-center">
                <Col xl={4} md={6} className="d-block d-xl-none">
                  <div className="dropdown-wrapper position-relative">
                    <button
                      className="pointer"
                      onClick={(e) => {
                        this.setState(
                          this.state.active == 3
                            ? { active: -1 }
                            : { active: 3 }
                        );
                      }}
                      onBlur={(e) => {
                        this.setState(
                          this.state.active == 3
                            ? { active: -1 }
                            : { active: 3 }
                        );
                      }}
                    >
                      Past Events{" "}
                      <i className="fa fa-angle-down px-2 text-red-1"></i>
                    </button>
                    <div
                      className={`cdropdown-items ${
                        this.state.active == 3 ? "active" : ""
                      }`}
                    >
                      <div className="cdropdown-item">No Record Found</div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} md={6} className="mt-3 mt-md-0">
                  <div className="position-relative searchbar-wrapper">
                    <input
                      type="text"
                      className="form-control bg-dark-1"
                      placeholder="Search"
                      onChange={(e) => {
                        this.setState({ searchText: e.target.value });
                      }}
                    />
                    <span
                      className="position-absolute"
                      style={{
                        top: "50%",
                        right: "25px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <i className="fa fa-search" />
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row> */}
        </Container>
        <div className="mb-5">
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            className="bg-dark-1"
          >
            <ModalHeader className="bg-dark-1 text-white-1 tex">
              Gallery
            </ModalHeader>
            <ModalBody className="bg-dark-1 text-white-1">
              <UncontrolledCarousel
                items={
                  this.state.images.map((im, index) => {
                    return {
                      src: im,
                      altText: "",
                      caption: "",
                      header: "",
                      key: index + 1,
                    };
                  })
                  //   [
                  //   {
                  //     src: img1,
                  //     altText: "",
                  //     caption: "",
                  //     header: "",
                  //     key: "1",
                  //   },
                  //   {
                  //     src: img2,
                  //     altText: "",
                  //     caption: "",
                  //     header: "",
                  //     key: "2",
                  //   },
                  //   {
                  //     src: img3,
                  //     altText: "",
                  //     caption: "",
                  //     header: "",
                  //     key: "3",
                  //   },
                  // ]
                }
              />
            </ModalBody>
          </Modal>
          {gallery &&
            gallery.map((gal, index) => {
              if (index % 2 == 0) {
                return (
                  <Container className="mt-5">
                    <div
                      onClick={(e) => {
                        this.setState({ images: gal.images });
                        this.toggle(e);
                      }}
                      className="gallery-container bg-dark-1"
                    >
                      <Row>
                        <Col xl={5} className="pe-xl-0">
                          <div
                            className="gallery-main-1 text-white-1 position-relative shadow-custom"
                            style={{
                              backgroundImage: `url("${gal.images[0]}")`,
                            }}
                          >
                            <div
                              className="position-absolute px-3 w-100"
                              style={{ bottom: 0 }}
                            >
                              <h5 className="font-weight-bold">{gal.title}</h5>
                              <div className="d-flex">
                                <p>{gal.location}</p>
                                <p className="ms-auto">
                                  {moment(gal.date).format("DD MMM YYYY")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={7}>
                          <div className="padding-fix ps-xl-0">
                            <Row className="justify-content-center">
                              {gal.images
                                .filter((img, index) => {
                                  return index != 0;
                                })
                                .map((im) => {
                                  return (
                                    <Col xl={4} lg={4} sm={4} xs={8}>
                                      <div
                                        className="gallery-sub gallery-sub-1 shadow-custom"
                                        style={{
                                          backgroundImage: `url("${im}")`,
                                        }}
                                      ></div>
                                    </Col>
                                  );
                                })}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                );
              } else {
                return (
                  <Container className="mt-5">
                    <div
                      onClick={(e) => {
                        this.setState({ images: gal.images });
                        this.toggle(e);
                      }}
                      className="gallery-container bg-dark-1"
                    >
                      <Row>
                        <Col xl={7} className="order-2 order-xl-1">
                          <div className="padding-fix ps-xl-0">
                            <Row className="justify-content-center">
                              {gal.images
                                .filter((img, index) => {
                                  return index != 0;
                                })
                                .map((im) => {
                                  return (
                                    <Col xl={4} lg={4} sm={4} xs={8}>
                                      <div
                                        className="gallery-sub gallery-sub-1 shadow-custom"
                                        style={{
                                          backgroundImage: `url("${im}")`,
                                        }}
                                      ></div>
                                    </Col>
                                  );
                                })}
                            </Row>
                          </div>
                        </Col>
                        <Col xl={5} className="order-1 order-xl-2 pe-xl-0">
                          <div
                            style={{
                              backgroundImage: `url("${gal.images[0]}")`,
                            }}
                            className="gallery-main-2 text-white-1 position-relative shadow-custom"
                          >
                            <div
                              className="position-absolute px-3 w-100"
                              style={{ bottom: 0 }}
                            >
                              <h5 className="font-weight-bold">{gal.title}</h5>
                              <div className="d-flex">
                                <p>{gal.location}</p>
                                <p className="ms-auto">
                                  {moment(gal.date).format("DD MMM YYYY")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                );
              }
            })}
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    game: state.game,
    gallery: state.gallery.gallery,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    getGallery: () => dispatch(getGallery()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
